import { Loader } from "lucide-react";
import { FC } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteTagMutation } from "@/data/mutations";
import { useDialogState } from "@/hooks/use-dialog-state";

type Props = {
  tagId: string;
};

export const DeleteTagDialog: FC<Props> = ({ tagId }) => {
  const { dialog, closeDialog } = useDialogState();
  const deleteTagMutation = useDeleteTagMutation();

  const handleSubmit = () => {
    deleteTagMutation.mutate(tagId);
  };

  return (
    <AlertDialog open={dialog?.name === "delete-tag"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Tag {tagId}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this tag?{" "}
            <i className="text-black">
              This action is irreversible and the tag cannot be programmed
              again.
            </i>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={deleteTagMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteTagMutation.isPending}
          >
            {deleteTagMutation.isPending ? (
              <Loader className="animate-spin" />
            ) : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
